import React from "react";
import { ROUTE_ROOT, ROUTE_CRM, ROUTE_DEMOS } from "./routes";
import { ContactsOutlined, FileDoneOutlined, ApiOutlined } from "@ant-design/icons";

export const MENU_ITEM_ADMIN = "Admin";

// Menu items should be registered via helper function
const MENU_ITEMS = {
  [ROUTE_ROOT]: {
    icon: <ContactsOutlined />,
    translationKey: "menus.leftMenu.customers",
  },
  [ROUTE_CRM]: {
    icon: <FileDoneOutlined />,
    translationKey: "menus.leftMenu.crm",
  },
  [ROUTE_DEMOS]: {
    icon: <ApiOutlined />,
    translationKey: "menus.leftMenu.demos",
  },
};

export default MENU_ITEMS;
